module.exports = __webpack_public_path__ + "img/zhangwei.b79d2a2a.jpg";